export class domain {
    state: boolean;
    prefix: string;
    price: string;
    id: string;
    btnLink: string;
    btnId: string;
}
